// This file is generated by pnpm icons:generate. Do not edit.

import {createSinglePathSVG} from './TEMPLATE'

export const Leaf_Stroke2_Corner0_Rounded = createSinglePathSVG({
  path: 'M20.948 3.757a.75.75 0 0 0-.705-.705c-7.137-.42-12.854 1.73-15.291 5.76a8.16 8.16 0 0 0-1.196 4.594c.053 1.493.488 3 1.292 4.486L3.22 19.72a.75.75 0 0 0 1.062 1.062l1.828-1.83c1.485.804 2.993 1.239 4.485 1.292q.156.006.312.006a8.15 8.15 0 0 0 4.281-1.202c4.032-2.437 6.181-8.153 5.761-15.291Zm-6.534 14.009c-2.133 1.292-4.657 1.312-7.191.072l8.309-8.308a.75.75 0 0 0-1.062-1.062l-8.308 8.313c-1.236-2.531-1.219-5.062.072-7.191 2.071-3.42 6.994-5.292 13.248-5.068.224 6.249-1.649 11.173-5.068 13.244Z',
  viewBox: '0 0 24 24',
  glyph: 'Leaf_Stroke2_Corner0_Rounded',
})
